"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardItemClient = void 0;
const sdk_contants_1 = require("../../constants/sdk.contants");
const serializers_1 = require("../serializers");
const standard_item_hierarchy_serializer_1 = require("../serializers/standard-item-hierarchy.serializer");
const retryable_1 = require("./retryable");
class StandardItemClient {
    static newInstance(options, retryOptions) {
        const standardItemSerializer = new serializers_1.StandardItemSerializer();
        const standardSetSerializer = new serializers_1.StandardSetSerializer();
        const standardItemHierarchySerializer = new standard_item_hierarchy_serializer_1.StandardItemHierarchySerializer(standardSetSerializer, standardItemSerializer);
        return new StandardItemClient(retryable_1.RetryableHttpClient.newInstance(options, retryOptions), standardItemSerializer, standardItemHierarchySerializer);
    }
    constructor(client, standardItemSerializer, standardItemHierarchySerializer) {
        this.client = client;
        this.standardItemSerializer = standardItemSerializer;
        this.standardItemHierarchySerializer = standardItemHierarchySerializer;
    }
    async findByGlobalId(globalIds, include, headers) {
        const params = {
            globalId: globalIds,
            includeAncestors: include.ancestors,
            includeChildren: include.children,
            includeExamples: include.examples,
        };
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems.findByGlobalId`, {
            headers,
            params,
        });
        return response.body.data.map((standardItem) => this.standardItemSerializer.serializeOne(standardItem));
    }
    async findByGlobalIdWithPost(standardItemFindByGlobalIdDto, headers) {
        const response = await this.client.post(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems.findByGlobalId`, standardItemFindByGlobalIdDto, {
            headers,
        });
        return response.body.data.map((standardItem) => this.standardItemSerializer.serializeOne(standardItem));
    }
    async findFoundationalByCode(codes, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems.findFoundationalByCode`, {
            headers,
            params: { code: codes },
        });
        return response.body.data.map((standardItem) => this.standardItemSerializer.serializeOne(standardItem));
    }
    async getAllStandardItemMappings(standardItemGlobalId, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItemMapping`, {
            headers,
            params: { standardItemGlobalId },
        });
        return response.body.data.map((standardItem) => this.standardItemSerializer.serializeMapping(standardItem));
    }
    async checkStandardItemMapping(standardItemGlobalId, mappedStandardItemGlobalId, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItemMapping.check`, {
            headers,
            params: {
                standardItemGlobalId,
                mappedStandardItemGlobalId,
            },
        });
        return response.body.data;
    }
    async findByGlobalIdAddHierarchyTreeAndOrder(globalIds, include, headers) {
        const params = {
            globalId: globalIds,
            includeAncestors: include.ancestors,
            includeChildren: include.children,
            includeExamples: include.examples,
            skipValidateStandardSets: include.skipValidateStandardSets,
        };
        const response = await this.client.post(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems.hierarchyTreeOrder.findByGlobalId`, params, {
            headers,
        });
        return response.body.data.map((standardItem) => this.standardItemHierarchySerializer.serializeOne(standardItem));
    }
    async getSearchStandardsItems(filter, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems/search`, {
            headers,
            params: filter,
        });
        return this.standardItemSerializer.serializeStandardItemSearch(response.body.data);
    }
    async updateStandardHierarchyLevel(standardSetId, oldHierarchy, newHierarchy, headers) {
        const response = await this.client.put(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems/bulk/hierarchy`, {
            standardSetId,
            oldHierarchy,
            newHierarchy,
        }, {
            headers,
        });
        return this.standardItemSerializer.serializeRowsAffected(response.body.data);
    }
    async updateStatusByStandardSetAndHierarchyLevel(standardSetId, hierarchyLevel, newStatus, headers) {
        const response = await this.client.put(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems/bulk/status`, {
            standardSetId,
            hierarchyLevel,
            newStatus,
        }, {
            headers,
        });
        return this.standardItemSerializer.serializeRowsAffected(response.body.data);
    }
    async getIncompleteItemsAction(standardSetId, page, limit, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems/incomplete`, {
            params: {
                standard_set_id: standardSetId,
                page: page,
                limit: limit,
            },
            headers,
        });
        return this.standardItemSerializer.serializeStandardItemSearch(response.body.data);
    }
    async updateStatusOnStandardItemAndFamily(standardItemId, newStatus, headers) {
        const response = await this.client.put(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems/bulk/related/status`, {
            standardItemId,
            newStatus,
        }, {
            headers,
        });
        return response.body.data.map((si) => this.standardItemSerializer.serializeOne(si));
    }
    async getStandardItemByGlobalId(filter, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems/findOneByGlobalId`, {
            headers,
            params: filter,
        });
        return response.body.data;
    }
    async getDescendents(globalId, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems/descendents`, {
            headers,
            params: { globalId: globalId },
        });
        return response.body.data;
    }
    async getTreeFamily(globalId, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItems/family`, {
            headers,
            params: { globalId: globalId },
        });
        return response.body.data;
    }
}
exports.StandardItemClient = StandardItemClient;
//# sourceMappingURL=standard-item.client.js.map